import {US_STATES} from '@common/constants/usStates';
import {SelectField} from '@client/pages/public/enroll/checkout/fields/SelectField';

const STATE_OPTIONS = US_STATES.map((state) => ({value: state.code, label: state.name}));

export function StateSelect({
  name,
  label,
  className,
}: {
  name: string;
  label: string;
  className?: string;
}) {
  return (
    <SelectField
      name={name}
      label={label}
      options={STATE_OPTIONS}
      placeholder='Select state'
      className={className}
    />
  );
}
